import { backToGuideMessagingFromFileViewer } from './GuideMessagingModal';

const FileViewer = () => {
    backToGuideMessagingFromFileViewer();
    return null;
};

export default FileViewer;
